<template>
  <v-card>
    <div class="modal">
      <div class="modal-content" style="width: 100%">
        <s-toolbar
          :label="'Impresión de Fotocheck'"
          dark
          :color="'#BAB6B5'"
          close
          @close="close()"
          class="mb-6"
          print
          @print="downloadPdf()"
        ></s-toolbar>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          :filename="'FOTOCHECK '"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="297mm"
          :manual-pagination="true"
          :margin="1"
          :htmlToPdfOptions="htmlToPdfOptions"
          @beforeDownload="beforeDownload($event)"
          :autoPaging="true"
          ref="html2Pdf"
        >
          <section slot="pdf-content" id="pdf-content" style="height: 100%; width: 297mm">
            <!-- NUEVO DISEÑO (CardBuilder / CardBackBuilder) -->
            <div
              v-for="(group, pageIndex) in groupedItems"
              :key="pageIndex"
              class="pdf-page"
            >
              <!-- Estructura igual al HTML antiguo (table/tr/td) para respetar layout en PDF -->
              <table class="cards-table">
                <colgroup>
                  <col style="width: 57mm" />
                  <col style="width: 57mm" />
                  <col style="width: 57mm" />
                  <col style="width: 57mm" />
                  <col style="width: 57mm" />
                </colgroup>
                <tr class="cards-tr">
                  <td
                    v-for="(item, index) in group"
                    :key="getItemKey(item, index)"
                    class="cards-td"
                  >
                    <div class="card-face">
                      <img
                        v-if="frontImages[getItemKey(item, index)]"
                        :src="frontImages[getItemKey(item, index)]"
                        class="card-image"
                        alt="Fotocheck - Frente"
                      />
                      <div v-else class="card-placeholder">Generando...</div>
                    </div>

                    <div class="card-back">
                      <img
                        v-if="backImages[getItemKey(item, index)]"
                        :src="backImages[getItemKey(item, index)]"
                        class="card-image rotate-180"
                        alt="Fotocheck - Reverso"
                      />
                      <div v-else class="card-placeholder rotate-180">
                        Generando...
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </vue-html2pdf>

        <!-- Generadores ocultos: se usan para construir imágenes (base64) con el diseño nuevo -->
        <div style="display: none">
          <card-builder
            v-for="(w, i) in itemsCard"
            :key="'front-' + getItemKey(w) + '-' + i"
            :worker="w"
            ref="frontBuilders"
          />
          <card-back-builder
            v-for="(w, i) in itemsCard"
            :key="'back-' + getItemKey(w) + '-' + i"
            :worker="w"
            ref="backBuilders"
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";
//import jsPDF from 'jspdf';
import _sHelper from "@/services/HelperService";
import qrCode from "vue-qr-generator";
import QrcodeVue from "qrcode.vue";
import CardBuilder from "./CardBuilder.vue";
import CardBackBuilder from "./CardBackBuilder.vue";

export default {
  props: {
    itemsCard: { type: Array, default: () => [] },
    listImage: { type: Array, default: () => [] },
  },
  components: {
    VueHtml2pdf,
    qrCode,
    QrcodeVue,
    CardBuilder,
    CardBackBuilder,
  },
  data: () => ({
    SignatureImage: null,
    SignatureImageSuper: null,
    BossName: "GINO HERNAN BENITES CIEZA",
    items: [],
    listImagen2: [],
    headers: [
      { text: "Código Artículo", value: "ArtCode" },
      { text: "Descripción", value: "DerDescription" },
      { text: "Unidad de Medida", value: "UnitMeasurement" },
      { text: "Cantidad", value: "DerQuantity" },
      { text: "Centro de Costo", value: "CceName" },
      { text: "Línea de Negocios", value: "BslName" },
      { text: "Tipo Costo", value: "TypeCostName" },
      { text: "Proyecto", value: "PrjName" },
    ],
    groupedItems: [],
    personImage: null,
    frontImages: {},
    backImages: {},
    generatingCards: false,
    htmlToPdfOptions: {
      margin: 0, // Deja que el CSS mande
      filename: `FOTOCHECK.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "landscape",
      },
      html2canvas: {
        useCORS: true,
        scale: 5,
        
        logging: false,
        scrollX: 0,
        scrollY: 0,
      },
    },
  }),
  methods: {
    getItemKey(item, index) {
      const dni =
        item && item.PrsDocumentNumber ? String(item.PrsDocumentNumber) : "";
      const ver =
        item && item.CrdVersion != null ? String(item.CrdVersion) : "";
      const type = item && item.TypeCard != null ? String(item.TypeCard) : "";
      return [dni, type, ver].filter(Boolean).join("-") || `idx-${index}`;
    },
    async generateAllCardImages() {
      if (!this.itemsCard || this.itemsCard.length === 0) return;

      this.generatingCards = true;
      this.frontImages = {};
      this.backImages = {};

      await this.$nextTick();

      const frontRefs = this.$refs.frontBuilders || [];
      const backRefs = this.$refs.backBuilders || [];
      const frontBuilders = Array.isArray(frontRefs) ? frontRefs : [frontRefs];
      const backBuilders = Array.isArray(backRefs) ? backRefs : [backRefs];

      // Secuencial para evitar picos de memoria (cada imagen es grande)
      for (let i = 0; i < this.itemsCard.length; i++) {
        const item = this.itemsCard[i];
        const key = this.getItemKey(item, i);

        try {
          const frontBuilder = frontBuilders[i];
          const backBuilder = backBuilders[i];

          if (
            frontBuilder &&
            typeof frontBuilder.generateImage === "function"
          ) {
            const imgFront = await frontBuilder.generateImage();
            if (imgFront) this.$set(this.frontImages, key, imgFront);
          }

          if (
            backBuilder &&
            typeof backBuilder.generateBackImage === "function"
          ) {
            const imgBack = await backBuilder.generateBackImage();
            if (imgBack) this.$set(this.backImages, key, imgBack);
          }
        } catch (e) {
          console.error("Error generando imágenes de fotocheck", e);
        }
      }

      this.generatingCards = false;
    },
    getTextoQR(item) {
      let name = `${item.NtpSurname},${item.NtpName}`;
      console.log("name1", name);
      let newName = "";
      for (let i = 0; i < name.length; i++) {
        if (name[i] === " ") {
          newName += " ";
        } else if (name[i].toLowerCase() === " ") {
          newName += ":";
        } else {
          newName += name[i];
        }
      }
      name = newName;

      console.log("name2", name);

      const text = `${item.PrsDocumentNumber},${item.TypeCard},${item.CrdVersion},${item.NtpID},${name},${item.CtrID}`;

      return text;
    },
    async downloadPdf() {
      window.scrollTo(0, 0);
      // Esperar un toque para que el DOM esté "quieto"
      await new Promise((resolve) => setTimeout(resolve, 500));

      this.$refs.html2Pdf.generatePdf();
    },

    formatDate(date) {
      return this.$fun
        .formatDateTimeShort12HView(date)
        .replace("AM", "a.m.")
        .replace("PM", "p.m.");
    },
    groupItems(items, groupSize = 5) {
      const grouped = [];
      for (let i = 0; i < items.length; i += groupSize) {
        grouped.push(items.slice(i, i + groupSize));
      }
      console.log("Grupossss", grouped);
      return grouped;
    },
    beforeDownload({ html2pdf, options, pdfContent }) {
      pdfContent.style.padding = "0";
        pdfContent.style.margin = "0";
    
      html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
          }
          const content = this.$refs.html2Pdf.$el.querySelector("#pdf-content");
          if (content) {
            content.style.border = "none";
          }
        })
        .save();
    },

    groupItemsDynamic(items, maxRowsPerPage = 5) {
      const grouped = [];
      let currentGroup = [];
      let rowCount = 0;

      items.forEach((item) => {
        currentGroup.push(item);
        rowCount++;

        if (rowCount === maxRowsPerPage) {
          grouped.push(currentGroup);
          currentGroup = [];
          rowCount = 0;
        }
      });

      if (currentGroup.length > 0) {
        grouped.push(currentGroup);
      }
      console.log("Grupossss", grouped);

      return grouped;
    },
    getImage(document) {
      _sHelper
        .getPhotoWorkerBase64(document, this.$fun.getUserID())
        .then((rsp) => {
          if (rsp.status === 200) {
            this.personImage = "data:image/jpg;base64," + rsp.data;

            return this.personImage;
          } else {
            console.error("No se pudo cargar la imagen");
          }
        })
        .catch((error) => {
          console.error("Error al obtener la imagen:", error);
        });
    },

    getQr() {
      var imgAll = document.querySelector("#qrCodeImg img");
      console.log("Image", imgAll);
    },
    close() {
      //this.itemsCard      = [];
      this.groupedItems = [];
      this.listImagen2 = [];
      this.listImagen = [];
      this.frontImages = {};
      this.backImages = {};
      this.$emit("close");
    },
    Initialize() {
      this.listImagen2 = this.listImage;
      this.groupedItems = this.groupItemsDynamic(this.itemsCard);
      this.generateAllCardImages();
    },
  },
  mounted() {
    console.log("referralGuideSelected", this.itemsCard);
  },
  created() {
    console.log("Items Cards", this.itemsCard);
    console.log("Items Images", this.listImage);
    this.listImagen2 = this.listImage;
    this.groupedItems = this.groupItemsDynamic(this.itemsCard);
    console.log("groupedItems", this.groupedItems);
    this.generateAllCardImages();
  },
  watch: {
    itemsCard() {
      this.Initialize();
    },
  },
};
</script>

<style >
.pdf-page {
    height: 209.5mm; /* Un pelín menos de 210mm evita el desborde accidental */
    width: 297mm;
    page-break-after: always;
    page-break-inside: avoid;
    overflow: hidden;
    box-sizing: border-box;
    display: block;
    position: relative;
    background-color: white;
}

.pdf-page:last-child {
    page-break-after: auto !important;
}
.cards-table {
    width: 297mm;
    table-layout: fixed;
    border-collapse: separate;
    /* Ajusta este valor para separar/pegar horizontalmente los fotochecks */
    border-spacing: 2mm 0;
    margin: 0;
    padding: 0;
}
.cards-tr {
  transform: translateY(10px);
}

.cards-td {
  padding: 0 !important;
  margin: 0 !important;
  width: 57mm !important;
  min-width: 57mm !important;
  max-width: 57mm !important;
  vertical-align: top;
  box-sizing: border-box;
}

.card-face,
.card-back {
  display: block;
    width: 57mm !important;
    height: 86.2mm !important;
    border: 1px dashed black;
    box-sizing: border-box;
    margin: 0; 
    overflow: hidden;
    position: relative;
}
.card-back {
    margin-top: 0.4mm; /* Ajusta este valor para separar/pegar la cara de arriba con la de abajo */
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block; /* Evita espacios fantasma debajo de la imagen */
}

.card-placeholder {
  font-size: 10px;
  color: #444;
}

.rotate-180 {
  transform: rotate(180deg);
}

.tr {
  page-break-inside: avoid;
  border: none !important;
}

.tbody tr {
  page-break-inside: avoid;
  margin-top: 10px;
  border: none !important;
}

.td {
  border: none !important;
}

.table {
  page-break-inside: avoid;
  border: none !important;
}
.div {
  page-break-inside: avoid;
}

.details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  margin-top: 10px;
  border-top: 4px double black;
  border-bottom: 4px double black;
}

.details-table th {
  border-bottom: 4px double black;
  text-align: center;
  /* padding: 8px; */
}

.details-table td {
  text-align: center;
  /* padding: 8px; */
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  border: 1px solid #000;
}
</style>